import { useDefaultTableStyling as sytlingOptions } from "./globalStyle";
import { Strings } from "../assets/res/en";
import QrCodeThumb from "../components/QrCodeThumb";

export default function programDataColumn({onQRCodeSelected}) {
  const columns = [
    { title: Strings.COLUMN_PROGRAM_DESCRIPTION, field: "description" },
    {
      title: Strings.COLUMN_GROUP,
      field: "groupDescription",
      render: (rowdata) =>
        rowdata.idGroup === 0 ? "No Group" : rowdata.groupDescription,
    },
    {
      title: Strings.COLUMN_LOCATION,
      field: "merchant",
      render: (rowdata) =>
        rowdata.idMerchant === 0 ? "No Location" : rowdata.merchant,
    },
    {
      title: "QR Code",
      field: "merchant",
      width: "5%",
      render: (rowdata) => {
        if(rowdata.qrCode)  console.log('Program Id', rowdata.idProgram,rowdata.qrCode)
       
        return(
          <div>
            <QrCodeThumb url={rowdata?.qrCode} onClick={() => onQRCodeSelected(rowdata)}/>
          </div>
        )
      }
    },
  ];

  return { columns, sytlingOptions };
}
